import React from 'react';

import feefoServiceRatingSvg from 'src/components/molecules/TrustBanner/feefo-service-rating-4.7.svg';
import * as styles from './ServiceRating.styles';

export const ServiceRating = () => (
  <div css={styles.serviceRating}>
    <h3>Our service is rated Excellent</h3>
    <a href="/reviews">
      <img alt="Feefo rating: 4.7" src={feefoServiceRatingSvg} />
    </a>
  </div>
);
